module.exports = __webpack_public_path__ + "images/icons/icon-hexagon-71c15061.svg";